import React, { Component } from 'react';
import _ from 'lodash';

import { withStyles, createStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { Grid } from '@material-ui/core';

import MyPATMathEditor, { MyPATMathEditorProps } from './MyPATMathEditor';
import { NONAME } from 'dns';
import { SectionFocusedContext, SectionFocusedContextValue } from './MyPATBaseSection';
import classNames from 'classnames';

interface MyPATMathFieldProps extends WithStyles<typeof styles> {
	editorProps: MyPATMathEditorProps,
	startAdorment: Component,
	endAdorment: Component,
	gridSize: any,
	variant: 'input'|'textarea'
}

const styles = (theme:Theme) => createStyles({
  root: {},
	mathFieldGrid: {
		'& .jodit_container': {
			position: 'relative',
      minHeight: "44px !important",
      minWidth: "60px !important",
      width: "100% !important",   
      '& .jodit_workplace': {
        minHeight: "44px !important",
        borderRadius: '4px',
      },   
    },
    '&>:nth-child(1)':{
      '&>:nth-child(1)':{
        '&>:nth-child(1)':{
          '&>:nth-child(2)':{
            // padding: '8px 10px 0px 10px'
          }
        },
      },
    },
    '& .jodit_toolbar': {
      display: 'none',
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .jodit_statusbar": {
      display: "none !important",
    },

    "& .jodit_wysiwyg": {
      'min-height': '46px !important'
    },
    "& .main-math-editor-workplace" :{      
      width:'100%',
      height:'100%',
      background:'#333333',
      content:'" "',
      position:'fixed',
      left:'0',
      top:'0',
      'z-index':'9',
      Opacity:"0.5",
    },
    "& .math-editor-workplace": {
      //minHeight: "180px !important",
      height: "auto",
      padding:"10px",
      position: "fixed",
      left: "50%",
      //top:"120px",
      //top: "85px",
      top:"15%",
      marginLeft:'-350px',
      borderRadius: '5px 5px 5px 5px',
      'z-index': "99",
      'border-top':"0px",
      width:"700px",
      background: "#ffffff",
      //'box-shadow':"4px 5px 6px #dfdfdf", 
      "& button:not([class])": {
        position: "absolute",
        bottom: 0,        
      }
    },
    "& .ML__fieldcontainer__field":{
      border:'solid 1px #ccc !important',
      padding:'15px',      
      marginBottom :'20px',
    },
    "& .ML__mathlive":{
      whitwSpace:'inherit',
    },
    "& .math-workplace-add":{
      color: "white",
      padding: "0 16px",
      background:"linear-gradient(90deg, #2E93FB 0%, #66b4fd 70%)",
      'background-color': '#2E93FB',
      height:"36px",
      'font-size':"0.875rem",
      'font-weight': "500",
      'border-radius': "4px",
      border:"0",
      'margin-right':"15px",
      cursor:'pointer',
    },
   '& .math-workplace-close':{
      color: "#666666",
      padding: "0 16px",
      background:"#ffffff",
      'background-color': '#ffffff',
      height:"36px",
      'font-size':"12px",
      'font-weight': "normal",
      'border-radius': "4px",
      border:"0",
      cursor:'pointer',
      float:"left",
      marginRight:"20px",
    },
    '& .add-latex-workplace':{
      width: '100%',
      border: '1px solid #c6c6c6',
      marginTop: '3px'
    },
    ".jodit_toolbar":{
      width:'auto !important',
    },
    "& .math-editor-textarea":{
      width: '94%',
      border: '1px solid #cfd5e0',
      padding: '5px'
    },
    " .jodit_workplace":{
      minHeight: '44px',
      borderRadius: '4px',
    }
  },
 

	mathTextAreaGrid: {
		'& .jodit_container': {
			position: 'relative',
      minHeight: "44px !important",
      minWidth: "60px !important",
      width: "100% !important"
    },
    '& .jodit_toolbar': {
      display: 'none',
      border: "none !important",
      boxShadow: "none !important",
    },
    "& .jodit_statusbar": {
      display: "none !important",
    },
    '& .latex-header': {
      margin: '1px 0px -4px',
      background: '#F4F7F8',
      border: 'solid 0.5px #9999',
      borderRadius: 4,
      padding: '0px 12px',
      height: 40,
      fontSize: 10
    },    
    "& .mathlive-header": {
      textAlign: 'center',
      marginLeft: '-48px',
      marginRight: '-48px',
      borderBottom: 'solid 1px #9999'
    }, 
    "& ML__fieldcontainer":{
      border: 'solid 1px #ccc',
      height: '44px'
    },
    "& .main-math-editor-workplace" :{      
      width:'100%',
      height:'100%',
      background:'#333333',
      content:'" "',
      position:'fixed',
      left:'0',
      top:'0',
      'z-index':'9',
      Opacity:"0.5",
    },
    "& .math-editor-workplace": {
      //minHeight: "180px !important",
      height: "auto",
      position: "fixed",
      left: "50%",
      //top:"120px",
      //top: "85px",
      top:"20%",
      marginLeft:'-350px',
      'z-index': "99",
      'border-top':"0px",
      width:"700px",
      background: "#ffffff",
      //'box-shadow':"4px 5px 6px #dfdfdf",      
      "& button:not([class])": {
        position: "absolute",
        bottom: 0,        
      },
      borderRadius: '5px 5px 5px 5px',
      padding: '0px 48px 20px'          
    },
    "& .ML__fieldcontainer__field":{
      border:'solid 1px #ccc !important',
      padding:'15px',      
      marginBottom :'20px',
    },
    "& .ML__mathlive":{
      whitwSpace:'inherit',
    },
    "& .math-workplace-add":{
      color: "white",
      padding: "0 16px",
      background:"linear-gradient(90deg, #2E93FB 0%, #66b4fd 70%)",
      'background-color': '#2E93FB',
      height:"36px",
      'font-family':"'Roboto', sans-serif",
      'font-size':"0.875rem",
      'font-weight': "500",
      'border-radius': "4px",
      border:"0",
      'margin-right':"15px",
      cursor:'pointer',
      marginRight:15,
      borderRadius: 4,
      backgroundColor: '#2E93FB',
      marginTop: 15,
      float: 'right'
    },
   '& .math-workplace-close':{
      color: "#666666",
      padding: "0 16px",
      background:"#ffffff",
      'background-color': '#ffffff',
      height:"36px",
      'font-family':"'Roboto', sans-serif",
      'font-size':"12px",
      'font-weight': "normal",
      'border-radius': "4px",
      border:"0",
      cursor:'pointer',
      float:"right",
      marginRight:15,
      borderRadius: 4,
      marginTop: 15
    },
    '& .add-latex-workplace':{
      width: '100%',
      border: '1px solid #c6c6c6',
      marginTop: '3px'
    },
    "& .math-editor-textarea":{
      width: '94%',
      border: '1px solid #cfd5e0',
      padding: '5px',
      backgroundColor: '#F4F7F8'//Custom added,
    },    
    '& .jodit_wysiwyg':{
      'min-height': '46px !important'
    },
    '& .jodit_workplace': {
      'min-height': '44px !important',
      'border-radius': '4px',
    },
  },
    "button.ML__virtual-keyboard-toggle":{
        "position": "absolute",
        right:"10px",
        bottom:"10px",    
    },
    "button.ML__virtual-keyboard-toggle:hover":{
        "position": "absolute",
        right:"10px",
        bottom:"10px",    
    }
});

const MyPATMathField = (props:MyPATMathFieldProps) => {
	const {
		classes,
		editorProps,
		startAdorment,
		endAdorment,
		gridSize = 12,
		variant = 'input',
	} = props;

	return (
    <SectionFocusedContext.Consumer>
      {({ setSectionFocus, focusedBorder }: SectionFocusedContextValue) => (
        <Grid
          container
          className={classes.root}
        >
          {_.isEmpty(startAdorment) ? null : startAdorment}
          <Grid
            item
            xs={gridSize}
            className={classNames(_.isEqual(variant, 'input') ? classes.mathFieldGrid : classes.mathTextAreaGrid)}
          >
            <MyPATMathEditor {...editorProps} setSectionFocus={setSectionFocus} />
          </Grid>
          {_.isEmpty(endAdorment) ? null : endAdorment}
        </Grid>
      )}
    </SectionFocusedContext.Consumer>
	)
}

export default withStyles(styles)(MyPATMathField);